import { NextRouter } from 'next/router';

export const fromObjects = [
  {
    id: 'wallet',
    pathname: '/dashboard/wallet',
  },
  {
    id: 'transactions',
    pathname: '/dashboard/wallet/transactions',
  },
  {
    id: 'orders',
    pathname: '/dashboard/wallet/orders',
  },
  {
    id: 'sessions',
    pathname: '/dashboard/sessions',
  },
  {
    id: 'newSession',
    pathname: '/dashboard/sessions/new',
  },
  {
    id: 'sessionsHistory',
    pathname: '/dashboard/sessions/history',
  },
  {
    id: 'security',
    pathname: '/dashboard/manager/security',
  },
  {
    id: 'affiliates.main',
    pathname: '/dashboard/affiliates',
  },
  // summary: 0,
  // referrals: 1,
  // leaderboard: 2,
  // sessions: 3,
  // earnings: 4,
  // campaigns: 5,
  // history: 6,
  {
    id: 'affiliates.summary',
    pathname: '/dashboard/affiliates/summary',
  },
  {
    id: 'affiliates.referrals',
    pathname: '/dashboard/affiliates/referrals',
  },
  {
    id: 'affiliates.leaderboard',
    pathname: '/dashboard/affiliates/leaderboard',
  },
  {
    id: 'affiliates.sessions',
    pathname: '/dashboard/affiliates/sessions',
  },
  {
    id: 'affiliates.earnings',
    pathname: '/dashboard/affiliates/earnings',
  },
  {
    id: 'affiliates.campaigns',
    pathname: '/dashboard/affiliates/campaigns',
  },
  {
    id: 'affiliates.history',
    pathname: '/dashboard/affiliates/history',
  },
] as const;

export default function getFromObject(router: NextRouter) {
  // Auto detect id
  const id: string | undefined = fromObjects?.find((obj) => {
    if (router.pathname.match(/\[\[\.\.\.(.*?)\]\]/g)) {
      const [, property] = /\[\[\.\.\.(.*?)\]\]/g.exec(router.pathname) || [];
      if (property) {
        const path = router.pathname.replace(
          /\[\[\.\.\.(.*?)\]\]/g,
          Array.isArray(router.query[property]) ? router.query[property]![0] || '' : ''
        );
        // remove / if found in the end of the path
        return path.replace(/\/$/, '') === obj.pathname;
      }
    }
    return obj.pathname === router.pathname;
  })?.id;

  if (!id) return undefined;
  // Define pathname
  let pathname = router.pathname;
  // When coming path is [[...pathname]] replace it with query.property[0]
  if (router.pathname.match(/\[\[\.\.\.(.*?)\]\]/g)) {
    const [, property] = /\[\[\.\.\.(.*?)\]\]/g.exec(router.pathname) || [];
    if (property) {
      const path = router.pathname.replace(
        /\[\[\.\.\.(.*?)\]\]/g,
        Array.isArray(router.query[property]) ? router.query[property]![0] || '' : ''
      );
      // remove / if found in the end of the path
      pathname = path.replace(/\/$/, '');
    }
  }
  // When coming path is [pathname] replace it with query[property]
  else if (router.pathname.match(/\[(.*?)\]/g)) {
    const [, property] = /\[(.*?)\]/g.exec(router.pathname) || [];
    if (property) {
      pathname = router.pathname.replace(/\[(.*?)\]/g, router.query[property] as string);
    }
  }

  return encodeURIComponent(
    Buffer.from(
      JSON.stringify({
        id,
        pathname,
        asPath: router.asPath,
      })
    ).toString('base64')
  );
}
